module.exports = __webpack_public_path__ + "static/media/trophy_with_ribbon.a2fbb649.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/trophy_with_ribbon.png
// module id = 959
// module chunks = 0